import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatTitle } from "@/lib/typography";
import { Glossaire } from "./Glossaire";

export const TimelinePage = () => {
  const phases = [
    {
      id: "P0",
      name: "Phase 0 — Préparation",
      period: "J−14 à J−1",
      items: [
        "Retail readiness totale — Brand Story — tags d'attribution",
        "Shadow campaigns — identifier 10 à 15 mots clés performants",
      ],
    },
    {
      id: "P1",
      name: "Phase 1 — Traction",
      period: "S1 à S2",
      items: [
        "SP Auto + Manuel — SB Vidéo",
        "Optimisations tous les 2 jours",
        "Focus CTR et CVR et premiers avis",
      ],
    },
    {
      id: "P2",
      name: "Phase 2 — Consolidation",
      period: "S3 à S4",
      items: [
        "Pause Auto si besoin — +20 à +30 % sur gagnants",
        "SD Views 7 à 30 — SB Banner et Store Spotlight",
        "Objectif — stabiliser ACoS et protéger TACoS",
      ],
    },
    {
      id: "P3",
      name: "Phase 3 — Expansion",
      period: "M2 à M3",
      items: [
        "SP Broad maîtrisé — SD Audiences si disponible",
        "SB multi créa",
        "Objectif — doubler le trafic sans dégrader TACoS",
      ],
    },
    {
      id: "P4",
      name: "Phase 4 — Optimisation Continue",
      period: "M3+",
      items: [
        "Hebdo — pruning et harvest et bids",
        "Mensuel — NTB% et SoV et refresh créas",
        "Trimestriel — saisonnalités",
      ],
    },
  ];

  const moments = [
    {
      q: "T1",
      notes: ["Janvier — tests à CPC bas", "Mars — montée avant Pâques"],
    },
    {
      q: "T2",
      notes: [
        "Avril à juin — pics beauté et sport et jardin",
        "+20 à +30 % SoV",
      ],
    },
    {
      q: "T3",
      notes: ["Été plus calme — SD retargeting", "Prime Day mi-juillet"],
    },
    {
      q: "T4",
      notes: [
        "Septembre — relance",
        "Octobre — pre holiday",
        "Novembre et décembre — Black Friday et Noël — x3 budget",
        "Fin décembre — réduire SoS",
      ],
    },
  ];

  const guardrails = [
    "Ne coupe pas l'apprentissage <7 jours — données bruitées sinon",
    "Change une variable à la fois — enchère OU mot-clé OU créa",
    "Maintiens ≥70 % du budget sur SP au départ — data exploitable",
    "Vérifie stock et prix avant de scaler — couverture ≥15 jours",
  ];

  const creativeHints = [
    "SB Vidéo — hook court (<2 s)",
    "Preuve sociale claire — visuels lisibles en petit cadré",
  ];

  const glossaire = [
    { term: "NTB%", definition: "Pourcentage de nouveaux acheteurs" },
    { term: "SoV", definition: "Share of Voice — part de voix" },
    { term: "SoS", definition: "Share of Spend — ajustement Top of Search" },
  ];

  return (
    <div className="space-y-4">
      {/* 1) TIMELINE */}
      <div>
        <h2 className="text-lg font-semibold mb-3">{formatTitle("1) Timeline — séquence et France")}</h2>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
          {phases.map((p) => (
            <Card key={p.id} className="hover:shadow-lg transition-shadow">
              <CardHeader className="pb-3">
                <div className="text-xs font-semibold uppercase tracking-wide text-primary">{p.period}</div>
                <CardTitle className="text-sm leading-tight">{p.name}</CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="list-disc pl-5 space-y-1 text-xs text-muted-foreground">
                  {p.items.map((it, i) => (
                    <li key={i}>{it}</li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>

      {/* 2) MOMENTS CLÉS FRANCE */}
      <Card>
        <CardHeader>
          <CardTitle>{formatTitle("2) Moments clés — France (saisonnalité)")}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
            {moments.map((m) => (
              <div key={m.q} className="rounded-lg border p-3">
                <div className="mb-2 font-semibold text-primary">{m.q}</div>
                <ul className="list-disc pl-5 text-xs space-y-1 text-muted-foreground">
                  {m.notes.map((n, i) => (
                    <li key={i}>{n}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {/* 3) RAPPELS GARDE-FOU */}
      <Card>
        <CardHeader>
          <CardTitle>{formatTitle("3) Rappels garde-fou")}</CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="list-disc pl-5 space-y-1 text-sm text-muted-foreground">
            {guardrails.map((g, i) => (
              <li key={i}>{g}</li>
            ))}
          </ul>
        </CardContent>
      </Card>

      {/* 4) ASTUCE CRÉATIVE */}
      <Card>
        <CardHeader>
          <CardTitle>{formatTitle("4) Astuce créative")}</CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="list-disc pl-5 space-y-1 text-sm text-muted-foreground">
            {creativeHints.map((h, i) => (
              <li key={i}>{h}</li>
            ))}
          </ul>
        </CardContent>
      </Card>

      {/* 5) GLOSSAIRE */}
      <Glossaire entries={glossaire} />
    </div>
  );
};
